import { defineStore } from 'pinia';

const useMetaStore = defineStore('meta', {
  state: () => ({
    loading: false,
  }),
});

export default useMetaStore;
